<template lang="html">
  <footer id="footer">
    <section class="top-section">
      <div class="container med-container">
  			<div class="row">
  				<div class="col-lg-6 col-left">
  					<p class="mb-4 mb-lg-3 text-center text-lg-left">
  						<router-link class="btn-logo" to="/">
  							<img src="public/images/logo.svg" alt="AVIP">
  						</router-link>
  					</p>

  					<div class="row">
  						<div class="col-sm-6 col-footer">
  							<p>
  								<router-link to="/empresa">Empresa</router-link>
  							</p>
  							<!-- <p>
  								<router-link to="/comunicados">Comunicados</router-link>
  							</p> -->
                <p>
  								<router-link to="/preguntas-frecuentes">Preguntas frecuentes</router-link>
  							</p>
  						</div>

  						<div class="col-sm-6 col-footer">
                <p>
  								<router-link to="/contacto">Contáctanos</router-link>
  							</p>
								<p>
  								<router-link to="/quejas-y-sugerencias">Quejas y sugerencias</router-link>
  							</p>
  						</div>
  					</div>
  				</div>

  				<div class="col-lg-6 mt-4 mt-lg-0 col-footer col-right">
            <b-form @submit="onSubmit">
              <b-form-group class="custom-f-group-s1">
                <b-form-input
                  v-model="formNewsletter.email"
                  type="email"
                  placeholder="INSCRIBETE A NUESTRO NEWSLETTER"
                  required
                ></b-form-input>
              </b-form-group>
              <b-button type="submit" class="btn-send"></b-button>
            </b-form>

            <div class="row mt-4">
              <div class="col-sm-6">
  							<p>
                  <router-link to="/politicas-de-compra">Políticas de compra</router-link>
                </p>
  							<p>
                  <router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>
                </p>
                <p>
                  <router-link to="/garantias">Garantías</router-link>
                </p>
              </div>

              <div class="col-sm-6 mt-3 mt-sm-0 text-center text-sm-right">
                <h6 class="title">© AVIP {{ currentYear }}</h6>
                <!-- <span class="address">
                  Calle 123
                </span> -->

                <!-- <span class="mt-2 copyright">© AVIP {{ currentYear }}</span> -->
              </div>
            </div>
          </div>
  			</div>
    	</div>
    </section>

  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: 0,

      formNewsletter: {
        email: '',
      },
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
  },

  beforeMount() {
    this.currentYear = new Date().getFullYear();
  },
}
</script>
